import { atom } from 'jotai';

/**
 * Jotai atoms for authentication state management
 * Manages user authentication state, session data (/me), loading states, and errors
 */
// Core authentication state atoms
const isAuthenticatedAtom = atom(false);
const userAtom = atom(null);
const accessTokenAtom = atom(null);
// Session data atom (from GET /me)
const meAtom = atom(null);
// Loading state atoms
const isAuthLoadingAtom = atom(true);
const isSigningInAtom = atom(false);
const isSigningOutAtom = atom(false);
// Error state atom
const authErrorAtom = atom(null);
// MFA enrollment state atom
// Set to true when user successfully logs in but has no enrolled MFA factors
const needsMfaEnrollmentAtom = atom(false);
// Derived atom for complete auth and session state
// Includes all auth state plus /me session data
const authStateAtom = atom((get) => ({
    isAuthenticated: get(isAuthenticatedAtom),
    user: get(userAtom),
    accessToken: get(accessTokenAtom),
    isLoading: get(isAuthLoadingAtom) || get(isSigningInAtom) || get(isSigningOutAtom),
    error: get(authErrorAtom),
    // Session data from /me endpoint
    me: get(meAtom),
    // MFA enrollment state
    needsMfaEnrollment: get(needsMfaEnrollmentAtom),
}));
// Action atom to clear authentication state (for logout)
const clearAuthStateAtom = atom(null, (_get, set) => {
    set(isAuthenticatedAtom, false);
    set(userAtom, null);
    set(accessTokenAtom, null);
    set(meAtom, null);
    set(authErrorAtom, null);
    set(needsMfaEnrollmentAtom, false);
});
// Action atom to clear auth errors
const clearAuthErrorAtom = atom(null, (_get, set) => {
    set(authErrorAtom, null);
});

export { accessTokenAtom, authErrorAtom, authStateAtom, clearAuthErrorAtom, clearAuthStateAtom, isAuthLoadingAtom, isAuthenticatedAtom, isSigningInAtom, isSigningOutAtom, meAtom, needsMfaEnrollmentAtom, userAtom };
//# sourceMappingURL=authAtoms.js.map
